import { useSelector } from 'react-redux';
import { useLocation, matchPath } from 'react-router-dom';
import { isSmallerSelector } from '../layout/mediaquery.js';
import {
	ROUTE_CAMPAIGN_REGISTER,
	ROUTE_CASINO_SEARCH,
	ROUTE_LIVE_CASINO_SEARCH,
	ROUTE_LIVE_CASINO_GAME,
	ROUTE_CASINO_GAME
} from '../router/constants.js';

const SMALLER_INVALID_ROUTES = [
	ROUTE_CASINO_GAME,
	ROUTE_CASINO_SEARCH,
	ROUTE_LIVE_CASINO_GAME,
	ROUTE_LIVE_CASINO_SEARCH
];
const INVALID_ROUTES = [ROUTE_CAMPAIGN_REGISTER];

const useLocationHasFooter = () => {
	const isSmaller = useSelector(isSmallerSelector);
	const location = useLocation();
	const isInvalidRoute = isSmaller
		? SMALLER_INVALID_ROUTES.some(route => matchPath(route, location.pathname))
		: INVALID_ROUTES.some(route => matchPath(route, location.pathname));
	// has footer if its a valid route
	return !isInvalidRoute;
};

export default useLocationHasFooter;
